import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  newsEvents: {
    id: 'views.ForInvestors.events.title',
    defaultMessage: 'Wydarzenia'
  },
  eventsButton: {
    id: 'views.ForInvestors.events.button',
    defaultMessage: 'Więcej wydarzeń'
  }
});



// WEBPACK FOOTER //
// ./src/common/components/UpcomingEvents/UpcomingEvents.intl.js